<script setup>
const techTheme = useTechTheme()
const currentTheme = techTheme.lowestLevelTheme
const voucherCookie = useCookie('voucher')
const message = computed(() => voucherCookie.value ? 'Please login or sign up to redeem your voucher.' : null)
</script>

<template>
  <div
    v-if="message"
    class="text-white">
    <span :class="currentTheme?.textColor || 'text-azure-radiance'">
      &bull;
    </span>
    {{ message }}
  </div>
</template>
